import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';

import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import CargoEdit from './edit';
import ContentManager from 'src/componentes/content-manager';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';

@autobind
class Cargo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saved: false,
    };
  }

  afterRemove = () => {
    this.setState({ saved: true });
  };

  handleDeleteClick = (item) => {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/Cargo/ValidarRestricoes"
        urlExclusao="/Cargo/Remove"
        item={item}
        afterRemove={this.afterRemove}
        //urlList="/CausaRisco"
        urlEdit="/Cargo/edit"
        isEdit={true}
      />
    );
  };

  renderNome(item) {
    const handleEdit = () => {
      ContentManager.addContent(
        <CargoEdit
          handleClose={(saved) => {
            saved &&
              this.setState({
                saved: !this.state.saved,
              });
          }}
          item={item}
          showDelete={true}
        />
      );
    };

    return (
      <a
        className="font-weight-bold text-primary cursor-pointer"
        onClick={() => handleEdit(item)}
      >
        {item.nome}
      </a>
    );
  }

  renderCriticidade(item) {
    return <span>{item.criticidade && item.criticidade.nome}</span>;
  }

  renderTipo(item) {
    return <span>{item.tipoCargo && item.tipoCargo.nome}</span>;
  }

  render() {
    let { intl } = this.props;

    return (
      <List
        url="/Cargo"
        editComponent={CargoEdit}
        sort="Nome"
        showSearch={true}
        saved={this.state.saved}
        {...this.props}
        tag={11002}
        onDeleting={this.handleDeleteClick}
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'nome' })}
          valueField="nome"
          valueFunction={this.renderNome}
          required
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'tipo' })}
          valueFunction={this.renderTipo}
          valueField="tipoCargo"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'descricao' })}
          valueField="descricao"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'idIntegracao' })}
          valueField="idIntegracao"
          sortField="idIntegracao"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'criticidade' })}
          valueFunction={this.renderCriticidade}
          valueField="criticidade"
          sortField="criticidade.Nome"
        />
      </List>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(Cargo));
